import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { AuthState, User } from '@/types';
import { useUIStore } from './uiStore';

interface AuthStore extends AuthState {
  setAuth: (user: User, company: { code: string; name: string; status: string }, role: string, canUsePOS: boolean, permissions?: AuthState['permissions']) => void;
  syncSession: (payload: {
    user: User;
    company: { code: string; name: string; status: string } | null;
    role: string;
    can_use_pos: boolean;
    permissions?: AuthState['permissions'];
  }) => void;
  clearAuth: () => void;
}

export const useAuthStore = create<AuthStore>()(
  persist(
    (set) => ({
      user: null, company: null, role: '', isAuthenticated: false, canUsePOS: false, permissions: undefined,
      setAuth: (user, company, role, canUsePOS, permissions) => {
        localStorage.setItem('company_code', company.code);
        useUIStore.getState().setLocked(false);
        set({ user, company, role, isAuthenticated: true, canUsePOS, permissions });
      },
      syncSession: ({ user, company, role, can_use_pos, permissions }) => {
        if (company?.code) localStorage.setItem('company_code', company.code);
        set({
          user,
          company: company || null,
          role,
          isAuthenticated: true,
          canUsePOS: can_use_pos,
          permissions,
        });
      },
      clearAuth: () => {
        localStorage.removeItem('company_code');
        useUIStore.getState().setLocked(false);
        set({ user: null, company: null, role: '', isAuthenticated: false, canUsePOS: false, permissions: undefined });
      },
    }),
    { name: 'auth-storage' }
  )
);
